import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ModalWrapper } from '../common';

export default function LoadingOverlay({ onClose, done = false }) {
  const { t } = useTranslation();
  return (
    <ModalWrapper maxWidth="modal-lg" variant="centered">
      {/* Title */}
      <h2 className="text-xl font-bold text-mono-900 text-center">
        {t('common.price_searching')}
      </h2>

      {/* Animated Progress Bar */}
      <div className="w-full max-w-[524px] h-1.5 bg-mono-100 rounded-full overflow-hidden">
        <div
          className="h-full bg-orange-500 rounded-full"
          style={done ? {
            width: '100%',
            transition: 'width 0.3s ease-in',
          } : {
            animation: 'loading-bar-fill 2.5s ease-out forwards',
          }}
        />
      </div>

      {/* Subtitle */}
      <p className="text-sm font-medium text-mono-500 text-center">
        {t('common.finding_best_vehicle')}
      </p>

      {/* Back Button */}
      <Button level="level4" width="responsive-200" onClick={onClose}>{t('common.go_back')}</Button>

      {/* Inline keyframes for progress bar animation */}
      <style>{`
        @keyframes loading-bar-fill {
          0%   { width: 0%; }
          100% { width: 90%; }
        }
      `}</style>
    </ModalWrapper>
  );
}
